import { OPEN_WIDGET } from '../constants/EventListeners';
export function triggerHostMessageOpenWidget(data) {
  if (window.hsCalling.triggerEvent) {
    window.hsCalling.triggerEvent({
      event: OPEN_WIDGET,
      data
    });
  }
}